export default "__VITE_ASSET__DVd2jfhe__"